import React from 'react'
import DashboardContainer from './DashboardContainer'

export default function DashboardScreen() {
    return <DashboardContainer />
}
